<template>
    <div>
        <b-table
            id="cdas"
            :items="resultado"
            :fields="fields"
            striped
            small
            responsive="sm"
            tbody-tr-class="rowClass"
            :no-local-sorting="true"
            @sort-changed="sortingChanged"
            :busy="configTable.load"
            show-empty
            >
            <div slot="table-busy" class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>

            <template slot="empty">
                <p class="my-auto">Nenhum registro encontrado.</p>
            </template>

            <template slot="HEAD_selecionar">
                <b-form-checkbox v-model="configTable.checkedAll" class="mx-auto justify-content-center text-center ml-1" @change="toggleAll" />
            </template>
            <template slot="selecionar" slot-scope="row">
                <template v-if="!row.item.idPai">
                    <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="row.item.checked" @change="toggleCheck($event, row.item, null, true)" />
                </template>
            </template>
            <template slot="1" slot-scope="row">
                <b-form-checkbox class="mb-1" :checked="row.item.checked" @change="toggleCheck($event, row.item, null, false)">
                    <template v-if="!row.item.idPai">
                        <p class="m-0 p-0" :class="{'texto-vermelho' : row.item.inativo, 'texto-azul' : row.item.autoInfracao}"><strong>{{ row.item.contribuinte }}</strong></p>
                    </template>
                    <template v-else>
                        <p :class="{'texto-azul' : row.item.autoInfracao}">{{ row.item.contribuinte }}</p>
                    </template>
                </b-form-checkbox>
            </template>
            <template slot="2" slot-scope="row">
                <template v-if="!row.item.idPai">
                    <p class="m-0 p-0" :class="{'texto-vermelho' : row.item.inativo, 'texto-azul' : row.item.autoInfracao}"><strong>{{ row.item.cpfCnpj | cpfCnpj }}</strong></p>
                </template>
                <template v-else>
                    <p :class="{'texto-azul' : row.item.autoInfracao}">{{ row.item.cpfCnpj | cpfCnpj }}</p>
                </template>
            </template>
            <template slot="3" slot-scope="row">
                {{ row.item.cadicms }}
            </template>
            <template slot="4" slot-scope="row">
                {{ row.item.tipoCredito }}
            </template>
            <template slot="5" slot-scope="row">
                <b-form-checkbox class="mb-1" :checked="divida.checked"  v-for="divida in row.item.dividas" :key="divida.id" @change="toggleCheck($event, row.item, divida, false)">
                    <p class="m-0 p-0" :class="{'texto-amarelo' : divida.prescricao}">
                        <b-link @click="abrirModalExtratoCda(divida.codCdaSefa)" class="m-0 p-0 text-center">
                            <span class="m-0 p-0">{{ divida.numeroDivida }}</span>
                        </b-link>
                        <b-link @click="downloadArquivo(divida.codCdaSefa, divida.numeroDivida)" class="m-0 p-0">
                            <span class="m-0 p-0"> (PDF)</span>
                        </b-link>
                        <i v-if="divida.prescricao" class="fa fa-warning texto-amarelo" /></p>
                </b-form-checkbox>
            </template>
            <template slot="6" slot-scope="row">
                <p class="mb-1 text-nowrap" v-for="divida in row.item.dividas" :key="divida.codCdaSefa">
                    {{ divida.origem }}
                </p>
            </template>
            <template slot="7" slot-scope="row">
                <p class="mb-1" v-for="divida in row.item.dividas" :key="divida.codCdaSefa">
                    {{ divida.dtInscricao }}
                </p>
            </template>
            <template slot="8" slot-scope="row">
                {{ row.item.comarca }}
            </template>
            <template slot="9" slot-scope="row">
                <p class="mb-1" v-for="divida in row.item.dividas" :key="divida.codCdaSefa">
                    {{ divida.valor | currency }}
                </p>
            </template>
            <template slot="10" slot-scope="row">
                <p class="mb-1" v-for="divida in row.item.dividas" :key="divida.codCdaSefa">
                    {{ divida.excecaoInativa }}
                </p>
            </template>
        </b-table>

        <ExtratoCda
            ref="extratoCda"
            @closeModal="closeModal" />
    </div>
</template>

<script>
import axios from 'axios'
import ExtratoCda from "../../shared/components/ExtratoCda";

export default {
    components: {ExtratoCda},
    props: ['resultado', 'fields', 'configTable', 'selecteds', 'processosSelecteds'],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false
            this.$emit('consultarDividas')
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage
        },
    },
    methods: {
        rowClass(item) {
            if (!item) return
            if (item.idPai) return 'table-sub-item'
        },
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.processosSelecteds.includes(el)) {
                        if(!el.idPai) {
                            this.processosSelecteds.push(el)
                        }
                    }
                    el.dividas.forEach(divida => {
                        divida.checked = true
                        if(this.selecteds.indexOf(divida) < 0) {
                            this.selecteds.push(divida)
                        }
                    })
                })
            } else {
                this.resultado.forEach(el => {

                    const index = this.processosSelecteds.indexOf(el)
                    this.processosSelecteds.splice(index, 1)

                    el.checked = false;
                    
                    el.dividas.forEach(divida => {
                        divida.checked = false
                        if(this.selecteds.includes(divida)) {
                            const index = this.selecteds.indexOf(divida)
                            this.selecteds.splice(index, 1)
                        }
                    })
                })
            }
        },
        toggleCheck(checked, item, divida, all) {
            if(checked) {
                item.checked = checked
                if(!this.processosSelecteds.includes(item)) {
                    if(!item.idPai) {
                        this.processosSelecteds.push(item)
                    }
                }
                if(divida) {
                    divida.checked = true
                    this.selecteds.push(divida)
                } else if(item.dividas.length) {
                    item.dividas.forEach(elChild => {
                        elChild.checked = true
                        this.selecteds.push(elChild)
                    })
                }


                if(all) {
                    item.checkedAll = true
                    this.resultado.forEach(el => {
                        if (el.idPai == item.id) {
                            if(!this.processosSelecteds.includes(el)) {
                                if(!el.idPai) {
                                    this.processosSelecteds.push(el)
                                }
                            }
                            el.checked = true
                            el.dividas.forEach(elChild => {
                                elChild.checked = true
                                this.selecteds.push(elChild)
                            })
                        }
                    })
                }
            } else {
                this.configTable.checkedAll = checked
                if(divida) {
                    divida.checked = false

                    const index = this.selecteds.indexOf(divida)
                    this.selecteds.splice(index, 1)

                    let hasDividaChecked = false
                    item.dividas.forEach(divida => {
                        if(divida.checked == true) {
                            hasDividaChecked = true
                        }
                    })

                    if(!hasDividaChecked) {
                        const index = this.processosSelecteds.indexOf(item)
                        this.processosSelecteds.splice(index, 1)

                        item.checked = false

                    }
                } else {
                    item.checked = false

                    const index = this.processosSelecteds.indexOf(item)
                    this.processosSelecteds.splice(index, 1)

                    item.dividas.forEach(elChild => {
                        elChild.checked = false
                        if(this.selecteds.includes(elChild)) {
                            const index = this.selecteds.indexOf(elChild)
                            this.selecteds.splice(index, 1)
                        }
                    })
                }

                if(all) {
                    item.checkedAll = false
                    this.resultado.forEach(el => {
                        if (el.idPai == item.id) {
                            const index = this.processosSelecteds.indexOf(el)
                            this.processosSelecteds.splice(index, 1)
                            el.checked = false
                            el.dividas.forEach(elChild => {
                                elChild.checked = false
                                const index = this.selecteds.indexOf(elChild)
                                this.selecteds.splice(index, 1)
                            })
                        }
                    })
                }

                this.configTable.checkedAll = false
            }
        },
        sortingChanged(ctx) {
            if(ctx.sortBy == 1) {
                this.configTable.sortField = 'contribuinte'
            }
            if(ctx.sortBy == 2) {
                this.configTable.sortField = 'cpfCnpj'
            }
            if(ctx.sortBy == 3) {
                this.configTable.sortField = 'cadicms'
            }
            if(ctx.sortBy == 4) {
                this.configTable.sortField = 'tipoCredito'
            }
            if(ctx.sortBy == 5) {
                this.configTable.sortField = 'numeroDivida'
            }
            if(ctx.sortBy == 6) {
                this.configTable.sortField = 'tipoOrigemReferencia'
            }
            if(ctx.sortBy == 7) {
                this.configTable.sortField = 'dataInscricao'
            }
            if(ctx.sortBy == 8) {
                this.configTable.sortField = 'comarca'
            }
            if(ctx.sortBy == 9) {
                this.configTable.sortField = 'valorTotal'
            }
            this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.$emit('sortingChanged')
        },
        async downloadArquivo(codCdaSefa, numeroDivida) {
            await axios.get(`${process.env.VUE_APP_ROOT_API}/v1/cdaDisponivelAjuizamento/baixarPdfAssinado/${codCdaSefa}`, {
                headers: {
                    'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                if(!response.data || !response.data.byteLength){
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                    window.scrollTo(0,0);
                    return;
                }

                let blob = new Blob([response.data], {type: 'application/pdf'});
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'certidao_' + numeroDivida + '.pdf';
                link.click();
            }).catch((error) => {
                this.exibirErro(error)
            });
        },
        abrirModalExtratoCda(codCdaSefa) {
            this.$refs['extratoCda'].abrirExtrato(codCdaSefa);
        },
        closeModal() {
            this.$refs['extratoCda'].fecharModais();
        },
    }

}
</script>

<style>

.texto-vermelho {
    color: red;
    font-weight: bold !important;
}

.texto-amarelo {
    color: #FFC107 !important;
    font-weight: bold !important;
}

.texto-azul {
    color: #0000FF !important;
    font-weight: bold !important;
}

</style>
